export const fleetFuelingCard = `
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.3/jquery.min.js"></script>
<div class="fsBody fsEmbed">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/css/3/reset_3d1cc6d59f.css">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/css/3/jquery-ui_eb08fdf84b.css">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/css/3/default-v4_febab48678.css">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/css/3/light_bb45d688b5.css">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/../common/css/uil-static.css">
<link rel="stylesheet" type="text/css" href="//static.formstack.com/forms/css/common/dialogs_00a7ec5f05.css">
<!--[if IE]>
    <link rel="stylesheet" type="text/css" media="all" href="https://secureit.formstack.com/forms/css/3/ie.css?20140508" />
<![endif]-->
<!--[if IE 7]><link rel="stylesheet" type="text/css" media="all" href="https://secureit.formstack.com/forms/css/3/ie7.css" /><![endif]-->
<!--[if IE 6]><link rel="stylesheet" type="text/css" media="all" href="https://secureit.formstack.com/forms/css/3/ie6fixes.css" /><![endif]-->
<form method="post" accept-charset="UTF-8" novalidate="" enctype="multipart/form-data" action="https://secureit.formstack.com/forms/index.php" class="fsForm fsMultiColumn" id="fsForm3293484">
<input type="hidden" name="form" value="3293484">
<input type="hidden" name="viewkey" value="ylHLiExZin">
<input type="hidden" name="password" value="">
<input type="hidden" name="hidden_fields" id="hidden_fields3293484" value="">
<input type="hidden" name="incomplete" id="incomplete3293484" value="">
<input type="hidden" name="incomplete_password" id="incomplete_password3293484">
<input type="hidden" name="referrer" id="referrer3293484" value="https://kwikfill.com/">
<input type="hidden" name="referrer_type" id="referrer_type3293484" value="js">
<input type="hidden" name="_submit" value="1">
<input type="hidden" name="style_version" value="3">
<input type="hidden" id="viewparam" name="viewparam" value="666115">
<div id="requiredFieldsError" style="display:none;">Please fill in a valid value for all required fields</div>
<div id="invalidFormatError" style="display:none;">Please ensure all values are in a proper format.</div>
<div id="resumeConfirm" style="display:none;">Are you sure you want to leave this form and resume later?</div>
<div id="resumeConfirmPassword" style="display: none;">Are you sure you want to leave this form and resume later? If so, please enter a password below to securely save your form.</div>
<div id="saveAndResume" style="display: none;">Save and Resume Later</div>
<div id="saveResumeProcess" style="display: none;">Save and get link</div>
<div id="fileTypeAlert" style="display:none;">You must upload one of the following file types for the selected field:</div>
<div id="embedError" style="display:none;">There was an error displaying the form. Please copy and paste the embed code again.</div>
<div id="applyDiscountButton" style="display:none;">Apply Discount</div>
<div id="dcmYouSaved" style="display:none;">You saved</div>
<div id="dcmWithCode" style="display:none;">with code</div>
<div id="submitButtonText" style="display:none;">Submit Form</div>
<div id="submittingText" style="display:none;">Submitting</div>
<div id="validatingText" style="display:none;">Validating</div>
<div id="autocaptureDisabledText" style="display:none;"></div>
<div id="paymentInitError" style="display:none;">There was an error initializing the payment processor on this form. Please contact the form owner to correct this issue.</div>
<div id="checkFieldPrompt" style="display:none;">Please check the field: </div>
<div id="translatedWord-fields" style="display:none;">Fields</div>
<div class="fsPage" id="fsPage3293484-1">
<div id="ReactContainer3293484" style="display:none" class="FsReactContainerInitApp" data-fs-react-app-id="3293484"></div>
    
                
                    
                                        
                                        
            
            <div class="fsSection fs4Col" id="fsSection72243510">
                                                    
                                        
            <div class="fsSectionHeader">
        
            <div class="fsSectionText"><p><span style="font-size: 24px;"><strong>Complete Your Application&nbsp;</strong></span><span style="font-size: 14px;"><strong>*required fields &nbsp; &nbsp; &nbsp; &nbsp;</strong></span></p><p style="text-align: center;"><span style="font-size: 18px;"><em><strong>For assistance with application call 1-800-443-3523 X-4837</strong></em></span></p></div>
    </div>
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-2" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243512" aria-describedby="fsSupporting72243512" fs-field-type="text" fs-field-validation-name="Full Legal Company Name" lang="en">
                                                                                                        <label id="label72243512" class="fsLabel fsRequiredLabel" for="field72243512">Full Legal Company Name<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243512" name="field72243512" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting72243512" class="fsSupporting">(Applicant or Buyer)</div>
                                                                        
                    
                    
                    
                                                <div data-lastpass-icon-root="true" style="position: relative !important; height: 0px !important; width: 0px !important; float: left !important;"></div></div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243513" aria-describedby="fsSupporting72243513" fs-field-type="phone" fs-field-validation-name="Phone #" lang="en">
                                                                                                        <label id="label72243513" class="fsLabel fsRequiredLabel" for="field72243513">Phone #<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243513" name="field72243513" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243513" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243514" aria-describedby="fsSupporting72243514" fs-field-type="phone" fs-field-validation-name="Fax  # " lang="en">
                                                                                                        <label id="label72243514" class="fsLabel" for="field72243514">Fax  #                                                     </label>
                                            
                                        
                    <input type="tel" id="field72243514" name="field72243514" size="2" value="" class="fsField fsFormatPhoneUS " data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243514" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-3" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243515" aria-describedby="fsSupporting72243515" fs-field-type="text" fs-field-validation-name="Company Name - Embossed on Cards" lang="en">
                                                                                                        <label id="label72243515" class="fsLabel fsRequiredLabel" for="field72243515">Company Name - Embossed on Cards<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243515" name="field72243515" size="50" required="" maxlength="20" value="" class="fsField fsFormatText fsRequired    fsFormatLength" aria-required="true">
                                                                                                        <div id="fsSupporting72243515" class="fsSupporting">Write company name as you wish it to appear on cards. Limit of 20 characters including spaces. Unless specified, no company name will appear on cards.</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72464106" aria-describedby="fsSupporting72464106" fs-field-type="text" fs-field-validation-name="Embossing on second line" lang="en">
                                                                                                        <label id="label72464106" class="fsLabel" for="field72464106">Embossing on second line                                                    </label>
                                            
                                        
                    <input type="text" id="field72464106" name="field72464106" size="50" maxlength="20" value="" class="fsField fsFormatText     fsFormatLength">
                                                                                                        <div id="fsSupporting72464106" class="fsSupporting"> Limit of 20 characters including spaces.</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-4" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243516" fs-field-type="text" fs-field-validation-name="DBA or AKA" lang="en">
                                                                                                        <label id="label72243516" class="fsLabel" for="field72243516">DBA or AKA                                                    </label>
                                            
                                        
                    <input type="text" id="field72243516" name="field72243516" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243517" fs-field-type="text" fs-field-validation-name="Subsidiary of" lang="en">
                                                                                                        <label id="label72243517" class="fsLabel" for="field72243517">Subsidiary of                                                    </label>
                                            
                                        
                    <input type="text" id="field72243517" name="field72243517" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72243518" aria-describedby="fsSupporting72243518" fs-field-type="text" fs-field-validation-name="Applicant's Taxpayer ID# " lang="en">
                                                                                                        <label id="label72243518" class="fsLabel fsRequiredLabel" for="field72243518">Applicant's Taxpayer ID# <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243518" name="field72243518" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting72243518" class="fsSupporting">(TIN, FEIN)</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-5" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72676464" fs-field-type="text" fs-field-validation-name="Applicant's SSN#" lang="en">
                                                                                                        <label id="label72676464" class="fsLabel" for="field72676464">Applicant's SSN#                                                    </label>
                                            
                                        
                    <input type="text" id="field72676464" name="field72676464" size="50" maxlength="9" value="" class="fsField fsFormatText     fsFormatLength">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72243520" fs-field-type="text" fs-field-validation-name="SIC Code or Type of Business" lang="en">
                                                                                                        <label id="label72243520" class="fsLabel" for="field72243520">SIC Code or Type of Business                                                    </label>
                                            
                                        
                    <input type="text" id="field72243520" name="field72243520" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-6" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243521" fs-field-type="text" fs-field-validation-name="Billing Contact" lang="en">
                                                                                                        <label id="label72243521" class="fsLabel fsRequiredLabel" for="field72243521">Billing Contact<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243521" name="field72243521" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-7" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243522" fs-field-type="text" fs-field-validation-name="Billing Address" lang="en">
                                                                                                        <label id="label72243522" class="fsLabel fsRequiredLabel" for="field72243522">Billing Address<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243522" name="field72243522" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243523" fs-field-type="text" fs-field-validation-name="City" lang="en">
                                                                                                        <label id="label72243523" class="fsLabel fsRequiredLabel" for="field72243523">City<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243523" name="field72243523" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243524" fs-field-type="text" fs-field-validation-name="State" lang="en">
                                                                                                        <label id="label72243524" class="fsLabel fsRequiredLabel" for="field72243524">State<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243524" name="field72243524" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243525" aria-describedby="fsSupporting72243525" fs-field-type="text" fs-field-validation-name="Zip +4" lang="en">
                                                                                                        <label id="label72243525" class="fsLabel fsRequiredLabel" for="field72243525">Zip +4<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243525" name="field72243525" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting72243525" class="fsSupporting">XXXXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-8" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243519" aria-describedby="fsSupporting72243519" fs-field-type="text" fs-field-validation-name="Headquarters Name, Physical Address, Phone # (If different than billing address)" lang="en">
                                                                                                        <label id="label72243519" class="fsLabel" for="field72243519">Headquarters Name, Physical Address, Phone # (If different than billing address)                                                    </label>
                                            
                                        
                    <input type="text" id="field72243519" name="field72243519" size="50" value="" class="fsField fsFormatText    ">
                                                                                                        <div id="fsSupporting72243519" class="fsSupporting">Do not include PO Box</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-9" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243526" fs-field-type="text" fs-field-validation-name="Principal(s)/Authorized Officer(s)" lang="en">
                                                                                                        <label id="label72243526" class="fsLabel fsRequiredLabel" for="field72243526">Principal(s)/Authorized Officer(s)<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243526" name="field72243526" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72243527" fs-field-type="text" fs-field-validation-name="Title(s)" lang="en">
                                                                                                        <label id="label72243527" class="fsLabel" for="field72243527">Title(s)                                                    </label>
                                            
                                        
                    <input type="text" id="field72243527" name="field72243527" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-10" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell85542654" fs-field-type="email" fs-field-validation-name="Email " lang="en">
                                                                                                        <label id="label85542654" class="fsLabel fsRequiredLabel" for="field85542654">Email <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="email" id="field85542654" name="field85542654" size="50" required="required" value="" class="fsField fsFormatEmail fsRequired" aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell85542734" aria-describedby="fsSupporting85542734" fs-field-type="phone" fs-field-validation-name="Phone # " lang="en">
                                                                                                        <label id="label85542734" class="fsLabel fsRequiredLabel" for="field85542734">Phone # <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field85542734" name="field85542734" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting85542734" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-11" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell85543200" aria-describedby="fsSupporting85543200" fs-field-type="text" fs-field-validation-name="In Business Since " lang="en">
                                                                                                        <label id="label85543200" class="fsLabel fsRequiredLabel" for="field85543200">In Business Since <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field85543200" name="field85543200" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting85543200" class="fsSupporting">(yyyy)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243529" aria-describedby="fsSupporting72243529" fs-field-type="text" fs-field-validation-name="Year of Incorporation" lang="en">
                                                                                                        <label id="label72243529" class="fsLabel fsRequiredLabel" for="field72243529">Year of Incorporation<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243529" name="field72243529" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting72243529" class="fsSupporting">(yyyy)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243530" fs-field-type="select" fs-field-validation-name="Fiscal Year Start " lang="en">
                                                                                                        <label id="label72243530" class="fsLabel fsRequiredLabel" for="field72243530">Fiscal Year Start <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <select id="field72243530" name="field72243530" size="1" required="" class="fsField fsRequired" aria-required="true">
        <option value="January">January</option>
        <option value="February">February</option>
        <option value="March">March</option>
        <option value="April">April</option>
        <option value="May">May</option>
        <option value="June">June</option>
        <option value="July">July</option>
        <option value="August">August</option>
        <option value="September">September</option>
        <option value="October">October</option>
        <option value="November">November</option>
        <option value="December">December</option>
</select>
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-12" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243531" fs-field-type="number" fs-field-validation-name="Avg. Month Fuel Expenditures" lang="en">
                                                                                                        <label id="label72243531" class="fsLabel fsRequiredLabel" for="field72243531">Avg. Month Fuel Expenditures<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                                            <span class="fsCurrency fsCurrencyPrefix">$</span>
            
        <input type="number" step="any" id="field72243531" name="field72243531" required="" value="0" class="fsField fsFormatNumber fsNumberMin-1 fsNumberMax-1000000000000 fsNumberDecimals-2 fsRequired" min="1" max="1000000000000" aria-required="true">
    
    <script>
    //This script is to address some quirkiness of Safari where commas are interchangeable with decimal points on number fields.
    //Normal attempts to restrict the comma such as our own validation or .replace(",", "") results in the value of the field being removed entirely.
    //Below the keypress itself is being blocked as a workaround to keep our value.
    document.getElementById("field72243531").addEventListener("keydown", function blockComma(e) {
    if (e.code === 'Comma') {
    e.preventDefault();}})
    </script>
                        <span class="fsCurrency fsCurrencySuffix"></span>
            
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243532" fs-field-type="number" fs-field-validation-name="Number of Cards" lang="en">
                                                                                                        <label id="label72243532" class="fsLabel fsRequiredLabel" for="field72243532">Number of Cards<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                        <div>
        <div id="field72243532-slider" class="fsSliderDiv ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"><a class="ui-slider-handle ui-state-default ui-corner-all" href="#" style="left: 0%;"></a></div>
        <div id="field72243532-slidervalue" class="fsSliderValue">1</div>
    </div>
    <div style="clear:both"></div>
    
    <input type="text" style="display:none" id="field72243532" name="field72243532" class="fsSlider fsNumberMin-1 fsNumberMax-30 fsNumberDecimals-0 fsRequired" aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-13" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243533" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><em>Designate the person authorized to receive all charge cards, reports and any other such information we provide from time to time and to take actions with respect to your account and account access. This is also the person designated by your company to provide all fleet vehicle driver and other information we may request.</em></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-14" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243534" fs-field-type="text" fs-field-validation-name="Primary Authorized Contact Name" lang="en">
                                                                                                        <label id="label72243534" class="fsLabel fsRequiredLabel" for="field72243534">Primary Authorized Contact Name<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243534" name="field72243534" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72243535" fs-field-type="text" fs-field-validation-name="Title" lang="en">
                                                                                                        <label id="label72243535" class="fsLabel fsRequiredLabel" for="field72243535">Title<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243535" name="field72243535" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-15" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243536" aria-describedby="fsSupporting72243536" fs-field-type="text" fs-field-validation-name="Mailing Address " lang="en">
                                                                                                        <label id="label72243536" class="fsLabel" for="field72243536">Mailing Address                                                     </label>
                                            
                                        
                    <input type="text" id="field72243536" name="field72243536" size="50" value="" class="fsField fsFormatText    ">
                                                                                                        <div id="fsSupporting72243536" class="fsSupporting">(if different from billing)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243537" fs-field-type="text" fs-field-validation-name="City" lang="en">
                                                                                                        <label id="label72243537" class="fsLabel" for="field72243537">City                                                    </label>
                                            
                                        
                    <input type="text" id="field72243537" name="field72243537" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243538" fs-field-type="text" fs-field-validation-name="State" lang="en">
                                                                                                        <label id="label72243538" class="fsLabel" for="field72243538">State                                                    </label>
                                            
                                        
                    <input type="text" id="field72243538" name="field72243538" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243539" aria-describedby="fsSupporting72243539" fs-field-type="text" fs-field-validation-name="Zip +4" lang="en">
                                                                                                        <label id="label72243539" class="fsLabel" for="field72243539">Zip +4                                                    </label>
                                            
                                        
                    <input type="text" id="field72243539" name="field72243539" size="50" value="" class="fsField fsFormatText    ">
                                                                                                        <div id="fsSupporting72243539" class="fsSupporting">XXXXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-16" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243540" fs-field-type="email" fs-field-validation-name="Email" lang="en">
                                                                                                        <label id="label72243540" class="fsLabel fsRequiredLabel" for="field72243540">Email<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="email" id="field72243540" name="field72243540" size="50" required="required" value="" class="fsField fsFormatEmail fsRequired" aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243541" aria-describedby="fsSupporting72243541" fs-field-type="phone" fs-field-validation-name="Phone #" lang="en">
                                                                                                        <label id="label72243541" class="fsLabel fsRequiredLabel" for="field72243541">Phone #<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243541" name="field72243541" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243541" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243542" aria-describedby="fsSupporting72243542" fs-field-type="phone" fs-field-validation-name="Fax #" lang="en">
                                                                                                        <label id="label72243542" class="fsLabel" for="field72243542">Fax #                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243542" name="field72243542" size="2" value="" class="fsField fsFormatPhoneUS " data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243542" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-17" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243543" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 18px;"><em><strong>IMPORTANT:&nbsp;</strong>If your estimated monthly vehicle expenditures equal $6,600 or more, please attach your most recent annual and current financial statements.</em></span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-18" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72280338" fs-field-type="file" fs-field-validation-name="Annual Financial Statement" lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72280338" id="label72280338">
                            <legend id="fsLegend72280338" class="fsLabel fsLabelVertical"><span>Annual Financial Statement</span></legend>
                            <div class="fieldset-content">
                    
                                        
                                <input type="file" style="display: none" id="field72280338" name="field72280338" size="30" class="fsField fsUpload uploadTypes-jpg,jpeg,gif,png,bmp,tif,psd,pdf,doc,docx,csv,xls,xlsx,txt,mp3,mp4,aac,wav,au,wmv,avi,mpg,mpeg,zip,gz,rar,z,tgz,tar,sitx">
    <input type="button" class="fsFileUploadButton" id="field72280338UploadButton" aria-controls="field72280338" value="Choose File">
    <input type="button" class="fsFileUploadButton" id="field72280338DeleteButton" aria-controls="field72280338" value="Remove File">
    <span class="fsFileUploadName" id="field72280338FileName">No File Chosen</span>
    <div class="showMobile">File uploads may not work on some mobile devices.</div>
    <script>
        (function () {
        var filename = document.getElementById('field72280338FileName').innerHTML
            function fileUploadClick() {
                var field = document.getElementById('field72280338');
                field.click();
                }
            function fileDelete() {
                document.getElementById('field72280338').value = '';
                document.getElementById('field72280338FileName').innerHTML = filename;
                }
            function onFileChange(event) {
                if (!event.target.files || !event.target.files.length) {
                    return;
                    }
                var file = event.target.files[0];
                var name = document.getElementById('field72280338FileName');
                name.innerHTML = file.name;
                }
                var button = document.getElementById('field72280338UploadButton');
            button.addEventListener('click', fileUploadClick);
            var field = document.getElementById('field72280338');
            field.addEventListener('change', onFileChange);
            var buttonDelete = document.getElementById('field72280338DeleteButton');
            buttonDelete.addEventListener('click', fileDelete);
            })()
    </script>
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72280395" fs-field-type="file" fs-field-validation-name="Current Financial Statement " lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72280395" id="label72280395">
                            <legend id="fsLegend72280395" class="fsLabel fsLabelVertical"><span>Current Financial Statement </span></legend>
                            <div class="fieldset-content">
                    
                                        
                                <input type="file" style="display: none" id="field72280395" name="field72280395" size="30" class="fsField fsUpload uploadTypes-jpg,jpeg,gif,png,bmp,tif,psd,pdf,doc,docx,csv,xls,xlsx,txt,mp3,mp4,aac,wav,au,wmv,avi,mpg,mpeg,zip,gz,rar,z,tgz,tar,sitx">
    <input type="button" class="fsFileUploadButton" id="field72280395UploadButton" aria-controls="field72280395" value="Choose File">
    <input type="button" class="fsFileUploadButton" id="field72280395DeleteButton" aria-controls="field72280395" value="Remove File">
    <span class="fsFileUploadName" id="field72280395FileName">No File Chosen</span>
    <div class="showMobile">File uploads may not work on some mobile devices.</div>
    <script>
        (function () {
        var filename = document.getElementById('field72280395FileName').innerHTML
            function fileUploadClick() {
                var field = document.getElementById('field72280395');
                field.click();
                }
            function fileDelete() {
                document.getElementById('field72280395').value = '';
                document.getElementById('field72280395FileName').innerHTML = filename;
                }
            function onFileChange(event) {
                if (!event.target.files || !event.target.files.length) {
                    return;
                    }
                var file = event.target.files[0];
                var name = document.getElementById('field72280395FileName');
                name.innerHTML = file.name;
                }
                var button = document.getElementById('field72280395UploadButton');
            button.addEventListener('click', fileUploadClick);
            var field = document.getElementById('field72280395');
            field.addEventListener('change', onFileChange);
            var buttonDelete = document.getElementById('field72280395DeleteButton');
            buttonDelete.addEventListener('click', fileDelete);
            })()
    </script>
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-19" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243544" fs-field-type="checkbox" fs-field-validation-name="Complete this section accurately. Check one:" lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72243544" id="label72243544">
                            <legend id="fsLegend72243544" class="fsLabel fsRequiredLabel fsLabelVertical"><span>Complete this section accurately. Check one:<span class="fsRequiredMarker">*</span></span></legend>
                            <div class="fieldset-content">
                    
                                        
                                                            <label class="fsOptionLabel horizontal" for="field72243544_1"><input type="checkbox" id="field72243544_1" name="field72243544[]" value="Corporation" class="fsField fsRequired horizontal" aria-required="true">Corporation</label>
                                                        <label class="fsOptionLabel horizontal" for="field72243544_2"><input type="checkbox" id="field72243544_2" name="field72243544[]" value="Proprietorship" class="fsField fsRequired horizontal" aria-required="true">Proprietorship</label>
                                                        <label class="fsOptionLabel horizontal" for="field72243544_3"><input type="checkbox" id="field72243544_3" name="field72243544[]" value="Partnership" class="fsField fsRequired horizontal" aria-required="true">Partnership</label>
                                                        <label class="fsOptionLabel horizontal" for="field72243544_4"><input type="checkbox" id="field72243544_4" name="field72243544[]" value="PC or PA" class="fsField fsRequired horizontal" aria-required="true">PC or PA</label>
                                                        <label class="fsOptionLabel horizontal" for="field72243544_5"><input type="checkbox" id="field72243544_5" name="field72243544[]" value="LLC" class="fsField fsRequired horizontal" aria-required="true">LLC</label>
                        
    
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-20" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243545" fs-field-type="checkbox" fs-field-validation-name="Is the account for a company that has been incorporated less than three years, a partnership, a proprietorship, a professional corporation or association, or a limited liability company?" lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72243545" id="label72243545">
                            <legend id="fsLegend72243545" class="fsLabel fsRequiredLabel fsLabelVertical"><span>Is the account for a company that has been incorporated less than three years, a partnership, a proprietorship, a professional corporation or association, or a limited liability company?<span class="fsRequiredMarker">*</span></span></legend>
                            <div class="fieldset-content">
                    
                                        
                                                            <label class="fsOptionLabel horizontal" for="field72243545_1"><input type="checkbox" id="field72243545_1" name="field72243545[]" value="No" class="fsField fsRequired horizontal" aria-required="true">No</label>
                                                        <label class="fsOptionLabel horizontal" for="field72243545_2"><input type="checkbox" id="field72243545_2" name="field72243545[]" value="Yes (If yes, complete the Personal Guaranty below.)" class="fsField fsRequired horizontal" aria-required="true">Yes (If yes, complete the Personal Guaranty below.)</label>
                        
    
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-21" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243546" fs-field-type="text" fs-field-validation-name="Primary Business Bank" lang="en">
                                                                                                        <label id="label72243546" class="fsLabel fsRequiredLabel" for="field72243546">Primary Business Bank<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243546" name="field72243546" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-22" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243547" fs-field-type="text" fs-field-validation-name="Address" lang="en">
                                                                                                        <label id="label72243547" class="fsLabel fsRequiredLabel" for="field72243547">Address<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243547" name="field72243547" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243548" fs-field-type="text" fs-field-validation-name="City" lang="en">
                                                                                                        <label id="label72243548" class="fsLabel fsRequiredLabel" for="field72243548">City<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243548" name="field72243548" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243549" fs-field-type="text" fs-field-validation-name="State" lang="en">
                                                                                                        <label id="label72243549" class="fsLabel fsRequiredLabel" for="field72243549">State<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243549" name="field72243549" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243550" aria-describedby="fsSupporting72243550" fs-field-type="text" fs-field-validation-name="Zip +4" lang="en">
                                                                                                        <label id="label72243550" class="fsLabel fsRequiredLabel" for="field72243550">Zip +4<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243550" name="field72243550" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                                                        <div id="fsSupporting72243550" class="fsSupporting">XXXXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-23" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243551" fs-field-type="text" fs-field-validation-name="Bank Contact Person" lang="en">
                                                                                                        <label id="label72243551" class="fsLabel fsRequiredLabel" for="field72243551">Bank Contact Person<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243551" name="field72243551" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72243552" aria-describedby="fsSupporting72243552" fs-field-type="phone" fs-field-validation-name="Phone # " lang="en">
                                                                                                        <label id="label72243552" class="fsLabel fsRequiredLabel" for="field72243552">Phone # <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243552" name="field72243552" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243552" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-24" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243553" fs-field-type="text" fs-field-validation-name="Commercial Account #" lang="en">
                                                                                                        <label id="label72243553" class="fsLabel fsRequiredLabel" for="field72243553">Commercial Account #<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243553" name="field72243553" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell72464349" aria-describedby="fsSupporting72464349" fs-field-type="phone" fs-field-validation-name="Fax # " lang="en">
                                                                                                        <label id="label72464349" class="fsLabel" for="field72464349">Fax #                                                     </label>
                                            
                                        
                    <input type="tel" id="field72464349" name="field72464349" size="2" value="" class="fsField fsFormatPhoneUS " data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72464349" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-25" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243554" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 18px;">Please provide three trade credit references for companies that issue you credit on a regular basis, suppliers or service companies. Do not provide credit card or oil company cards.*</span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-26" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243555" fs-field-type="text" fs-field-validation-name="Company Name" lang="en">
                                                                                                        <label id="label72243555" class="fsLabel fsRequiredLabel" for="field72243555">Company Name<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243555" name="field72243555" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243556" fs-field-type="text" fs-field-validation-name="City/State" lang="en">
                                                                                                        <label id="label72243556" class="fsLabel fsRequiredLabel" for="field72243556">City/State<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243556" name="field72243556" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243557" fs-field-type="text" fs-field-validation-name="Contact" lang="en">
                                                                                                        <label id="label72243557" class="fsLabel fsRequiredLabel" for="field72243557">Contact<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243557" name="field72243557" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243558" aria-describedby="fsSupporting72243558" fs-field-type="phone" fs-field-validation-name="Phone #  " lang="en">
                                                                                                        <label id="label72243558" class="fsLabel fsRequiredLabel" for="field72243558">Phone #  <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243558" name="field72243558" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243558" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-27" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243559" fs-field-type="text" fs-field-validation-name="Company Name " lang="en">
                                                                                                        <label id="label72243559" class="fsLabel fsRequiredLabel" for="field72243559">Company Name <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243559" name="field72243559" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243560" fs-field-type="text" fs-field-validation-name="City/State " lang="en">
                                                                                                        <label id="label72243560" class="fsLabel fsRequiredLabel" for="field72243560">City/State <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243560" name="field72243560" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243561" fs-field-type="text" fs-field-validation-name="Contact " lang="en">
                                                                                                        <label id="label72243561" class="fsLabel fsRequiredLabel" for="field72243561">Contact <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243561" name="field72243561" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243562" aria-describedby="fsSupporting72243562" fs-field-type="phone" fs-field-validation-name="Phone #   " lang="en">
                                                                                                        <label id="label72243562" class="fsLabel fsRequiredLabel" for="field72243562">Phone #   <span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="tel" id="field72243562" name="field72243562" size="2" required="" value="" class="fsField fsFormatPhoneUS  fsRequired" aria-required="true" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243562" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-28" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243563" fs-field-type="text" fs-field-validation-name="Company Name  " lang="en">
                                                                                                        <label id="label72243563" class="fsLabel" for="field72243563">Company Name                                                      </label>
                                            
                                        
                    <input type="text" id="field72243563" name="field72243563" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243564" fs-field-type="text" fs-field-validation-name="City/State  " lang="en">
                                                                                                        <label id="label72243564" class="fsLabel" for="field72243564">City/State                                                      </label>
                                            
                                        
                    <input type="text" id="field72243564" name="field72243564" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243565" fs-field-type="text" fs-field-validation-name="Contact  " lang="en">
                                                                                                        <label id="label72243565" class="fsLabel" for="field72243565">Contact                                                      </label>
                                            
                                        
                    <input type="text" id="field72243565" name="field72243565" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243566" aria-describedby="fsSupporting72243566" fs-field-type="phone" fs-field-validation-name="Phone #   " lang="en">
                                                                                                        <label id="label72243566" class="fsLabel" for="field72243566">Phone #                                                       </label>
                                            
                                        
                    <input type="tel" id="field72243566" name="field72243566" size="2" value="" class="fsField fsFormatPhoneUS " data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243566" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-29" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243567" fs-field-type="checkbox" fs-field-validation-name="" lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72243567" id="label72243567">
                            <legend id="fsLegend72243567" class="fsLabel fsLabelVertical"><span></span></legend>
                            <div class="fieldset-content">
                    
                                        
                                                            <label class="fsOptionLabel horizontal" for="field72243567_1"><input type="checkbox" id="field72243567_1" name="field72243567[]" value="Check if business is exempt from motor fuels tax. (Tax representative will provide further details.)" class="fsField horizontal">Check if business is exempt from motor fuels tax. (Tax representative will provide further details.)</label>
                        
    
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-30" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243568" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><em><strong>INFORMATION SHARING CLAUSE:</strong> United Refining Company and its affiliates may to the extent allowed by law and the terms of the Agreement, share all information disclosed or generated through this Application.</em></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
                                
                </div>
                                
            
                                        
                                        
            
            <div class="fsSection fs4Col" id="fsSection72243569">
                                                    
                                        
            <div class="fsSectionHeader">
        
            <div class="fsSectionText"><p style="text-align: center;"><span style="font-size: 14px;">AUTHORIZED SIGNATURE REQUIRED</span></p></div>
    </div>
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-32" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243570" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 14px;"><em>Any person signing on behalf of a legal entity attests that the Applicant is a valid business entity, that, if applicable, the execution of this Application has been duly authorized by all necessary action of the Applicant's governing body, and that the undersigned is authorized to make this Application on Applicant's behalf.</em></span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                                    
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-33" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243571" aria-describedby="fsSupporting72243571" fs-field-type="signature" fs-field-validation-name="Signature" lang="en">
                                                                                                        <label id="label72243571" class="fsLabel fsRequiredLabel" for="field72243571">Signature<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <!--[if lt IE 9]>
<script type="text/javascript" src="//formstack.com/forms/js/3/jsignature/flashcanvas.js"></script>
<![endif]-->
<!--[if gte IE 9]>
<script type="text/javascript">
    
    if (document.documentMode < 9){
        var url = '<script type="text/javascript" src="' + '//formstack.com/forms/' + 'js/3/jsignature/flashcanvas.js"><\/script>';
        document.write(url);
    }
    
</script>
<![endif]-->
        <div id="signature72243571" class="fsSignature"><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"></div><canvas style="margin: 0px; padding: 0px; border: medium none; height: 167px; width: 100%;" class="jSignature" width="666" height="167"></canvas><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"></div></div>
    <div style="text-align: right">
        <a href="javascript://" class="fsSignatureClear" id="signatureClear72243571">
                            [clear]
                    </a>
    </div>
    <input type="hidden" id="field72243571" value="" name="field72243571" required="" class="fsField fsRequired" aria-required="true">
                                                                                                        <div id="fsSupporting72243571" class="fsSupporting">Use your mouse or finger to draw your signature above</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-34" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243572" fs-field-type="datetime" fs-field-validation-name="Date/Time" lang="en">
                                                                                <fieldset role="group" aria-labelledby="fsLegend72243572" id="label72243572">
                            <legend id="fsLegend72243572" class="fsLabel fsRequiredLabel fsLabelVertical"><span>Date/Time<span class="fsRequiredMarker">*</span></span></legend>
                            <div class="fieldset-content">
                    
                                        
                                <!-- Used to pull in url for jquery -->
        <span aria-hidden="true" style="display:none;" id="fsCalendar72243572ImageUrl">https://secureit.formstack.com/forms/images/2/calendar.png</span>
    
    
    
    <input data-skip-validation="" data-date-format="M d, Y" type="hidden" id="field72243572Format" name="field72243572Format" value="MDY">
    
                    <div class="hidden"><label for="field72243572M">Month</label></div>
        <select id="field72243572M" name="field72243572M" class=" fsField fsRequired" aria-required="true">
                    <option value=""> </option>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                </select>
             <div class="hidden"><label for="field72243572D">Day</label></div>
        <select id="field72243572D" name="field72243572D" class=" fsField fsRequired" aria-required="true">
                    <option value=""> </option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                </select>
             <div class="hidden"><label for="field72243572Y">Year</label></div>
        <select id="field72243572Y" name="field72243572Y" class=" fsField fsRequired" aria-required="true">
                    <option value=""> </option>
                    <option value="2018">2018</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                </select>
    
    
            <script type="text/javascript">
            if (window.addEventListener) {
                window.addEventListener('load', function() {
                    Formstack.Util.setDate(72243572);
                }, false);
            } else if (window.attachEvent) {
                window.attachEvent('onload', function() {
                    Formstack.Util.setDate(72243572);
                });
            } else {
                Formstack.Util.setDate(72243572);
            }
        </script>
    
    <input data-skip-validation="" type="text" id="fsCalendar72243572Link" class="fsCalendarPickerLink hasDatepicker" style="display:none;" aria-hidden="true"><img class="ui-datepicker-trigger" src="https://secureit.formstack.com/forms/images/2/calendar.png" alt="Select Date" title="Select Date" aria-hidden="true">
        <div id="fsCalendar72243572" class="fsCalendar" style=" position:absolute"></div>
        
        <span class="always-ltr">
            <div class="hidden"><label for="field72243572H">Hour</label></div>
        <select id="field72243572H" name="field72243572H" class="fsField fsRequired" aria-required="true">
                    <option value=""> </option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                </select>
        <div class="hidden"><label for="field72243572I">Minute</label></div>
        <span>:</span> <select id="field72243572I" name="field72243572I" class="fsField fsRequired" aria-required="true">
                    <option value=""> </option>
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                </select>
        
                    &nbsp;
            <div class="hidden"><label for="field72243572A">AM/PM</label></div>
            <select id="field72243572A" name="field72243572A" class="fsField fsRequired" aria-required="true">
                            <option value=""> </option>
                            <option value="AM">AM</option>
                            <option value="PM">PM</option>
                        </select>
                <div class="fs-clear">
        </div>
    </span>
            <script type="text/javascript">
            if (window.addEventListener) {
                window.addEventListener('load', function() {
                    Formstack.Util.setTime(72243572);
                }, false);
            } else if (window.attachEvent) {
                window.attachEvent('onload', function() {
                    Formstack.Util.setTime(72243572);
                });
            } else {
                Formstack.Util.setTime(72243572);
            }
        </script>
    
                                                                
                    
                                                </div></fieldset>
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243573" fs-field-type="text" fs-field-validation-name="Print Name" lang="en">
                                                                                                        <label id="label72243573" class="fsLabel fsRequiredLabel" for="field72243573">Print Name<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243573" name="field72243573" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243574" fs-field-type="text" fs-field-validation-name="Title" lang="en">
                                                                                                        <label id="label72243574" class="fsLabel fsRequiredLabel" for="field72243574">Title<span class="fsRequiredMarker">*</span>                                                    </label>
                                            
                                        
                    <input type="text" id="field72243574" name="field72243574" size="50" required="" value="" class="fsField fsFormatText fsRequired   " aria-required="true">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-35" class="fsRow fsFieldRow fsLastRow fsHidden">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsHidden fsSpan100" id="fsCell72243575" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><em>Complete the personal Guaranty below only if this account is for a: Company that has been incorporated less than three years, b: Partnership, c: a Professional corporation or association, or d: Limited liability company.</em></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
                                
                </div>
                                
            
                                        
                                        
            
            <div class="fsSection fs4Col fsHidden" id="fsSection72243576">
                                                    
                                        
            <div class="fsSectionHeader">
        
            <div class="fsSectionText"><p style="text-align: center;"><span style="font-size: 14px;">PERSONAL GUARANTY</span></p></div>
    </div>
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-37" class="fsRow fsFieldRow fsLastRow fsHidden">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsHidden fsSpan100" id="fsCell72243577" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 14px;"><em>This Guaranty is made and entered into by the undersigned (the "Guarantor") in favor of United Refining Company and United Refining Company of Pennsylvania, together with their respective affiliates and subsidiaries (collectively"United"). Guarantor represents and warrants to United that Guarantor is a partner, shareholder, member, officer, director or other interested party in the business of (the "Applicant"). In order to induce United to grant or continue to extend credit to Applicant, Guarantor hereby agrees, for good and valuable consideration and intending to be legally bound, as follows: 1) Guarantor hereby guarantees and becomes surety for the payment and performance of all obligations of Applicant to United howsoever arising. Guarantor's obligations are primary, absolute and unconditional. Guarantor authorizes and agrees that United may, at any time and from time to time, without notice to Guarantor, renew, compromise, extend, increase, accelerate or otherwise change the time for performance, or the amount of any credit line or debt extended to or owed by Applicant. Guarantor further authorizes and agrees that United may, at any time and from time to time, without notice to Guarantor, hold, exchange, liquidate, waive or release, in whole or in part, collateral security for payment of the obligations of Applicant. 2) This is a Guaranty of payment and performance not merely collection. Guarantor waives any right to require United to attempt collection or otherwise proceed against Applicant, enforce a security interest in or collect from any collateral held by United, or to pursue any claim or remedy against Applicant or any other party prior to making demand upon Guarantor. Guarantor hereby waives any right of subrogation, reimbursement or indemnity against or by Applicant in favor of Guarantor, and further waives notice of protest, dishonor or acceptance. 3) Guarantor agrees to pay all costs of collection, including reasonable attorney's fees together with costs. 4) This Guaranty shall be binding upon and inure to the benefit of the heirs, personal representatives (if an individual), and successors and assigns of the parties. Nothing herein shall relieve the Guarantor under this Guaranty except a.) a written release by United; or b.) payment in full of the Applicant's obligations. This Guaranty shall be deemed made and shall be performable in the Commonwealth of Pennsylvania. Venue shall be in the state and federal courts having jurisdiction in and for Erie County, Pennsylvania, or such other place as United may select and in which an action hereunder may be brought.</em></span></p><p><span style="font-size: 14px;"><em>In witness whereof, the Guarantor (and each of them, jointly and severally if more than one) have caused the due execution hereof.</em></span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                                    
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-38" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243578" aria-describedby="fsSupporting72243578" fs-field-type="signature" fs-field-validation-name="Guarantor's Signature" lang="en">
                                                                                                        <label id="label72243578" class="fsLabel" for="field72243578">Guarantor's Signature                                                    </label>
                                            
                                        
                    <!--[if lt IE 9]>
<script type="text/javascript" src="//formstack.com/forms/js/3/jsignature/flashcanvas.js"></script>
<![endif]-->
<!--[if gte IE 9]>
<script type="text/javascript">
    
    if (document.documentMode < 9){
        var url = '<script type="text/javascript" src="' + '//formstack.com/forms/' + 'js/3/jsignature/flashcanvas.js"><\/script>';
        document.write(url);
    }
    
</script>
<![endif]-->
        <div id="signature72243578" class="fsSignature"><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"></div><canvas style="margin: 0px; padding: 0px; border: medium none; height: 25px; width: 100%;" class="jSignature" width="100" height="25"></canvas><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"></div></div>
    <div style="text-align: right">
        <a href="javascript://" class="fsSignatureClear" id="signatureClear72243578">
                            [clear]
                    </a>
    </div>
    <input type="hidden" id="field72243578" value="" name="field72243578" class="fsField" disabled="disabled">
                                                                                                        <div id="fsSupporting72243578" class="fsSupporting">Use your mouse or finger to draw your signature above</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-39" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243579" aria-describedby="fsSupporting72243579" fs-field-type="text" fs-field-validation-name="Date " lang="en">
                                                                                                        <label id="label72243579" class="fsLabel" for="field72243579">Date                                                     </label>
                                            
                                        
                    <input type="text" id="field72243579" name="field72243579" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243579" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243580" fs-field-type="text" fs-field-validation-name="Print Name " lang="en">
                                                                                                        <label id="label72243580" class="fsLabel" for="field72243580">Print Name                                                     </label>
                                            
                                        
                    <input type="text" id="field72243580" name="field72243580" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243581" aria-describedby="fsSupporting72243581" fs-field-type="text" fs-field-validation-name="Social Security No." lang="en">
                                                                                                        <label id="label72243581" class="fsLabel" for="field72243581">Social Security No.                                                    </label>
                                            
                                        
                    <input type="text" id="field72243581" name="field72243581" size="50" maxlength="9" value="000000000" class="fsField fsFormatText     fsFormatLength" disabled="disabled">
                                                                                                        <div id="fsSupporting72243581" class="fsSupporting">Without Dashes</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-40" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243582" aria-describedby="fsSupporting72243582" fs-field-type="text" fs-field-validation-name="Guarantor's Residential Address" lang="en">
                                                                                                        <label id="label72243582" class="fsLabel" for="field72243582">Guarantor's Residential Address                                                    </label>
                                            
                                        
                    <input type="text" id="field72243582" name="field72243582" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243582" class="fsSupporting">Street, City, State, Zip (Do not include PO Box)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243583" aria-describedby="fsSupporting72243583" fs-field-type="phone" fs-field-validation-name="Phone #    " lang="en">
                                                                                                        <label id="label72243583" class="fsLabel" for="field72243583">Phone #                                                        </label>
                                            
                                        
                    <input type="tel" id="field72243583" name="field72243583" size="2" value="" class="fsField fsFormatPhoneUS " disabled="disabled" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243583" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243584" aria-describedby="fsSupporting72243584" fs-field-type="text" fs-field-validation-name="Date of Birth" lang="en">
                                                                                                        <label id="label72243584" class="fsLabel" for="field72243584">Date of Birth                                                    </label>
                                            
                                        
                    <input type="text" id="field72243584" name="field72243584" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243584" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                                    
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-41" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243585" aria-describedby="fsSupporting72243585" fs-field-type="signature" fs-field-validation-name="Guarantor's Signature " lang="en">
                                                                                                        <label id="label72243585" class="fsLabel" for="field72243585">Guarantor's Signature                                                     </label>
                                            
                                        
                    <!--[if lt IE 9]>
<script type="text/javascript" src="//formstack.com/forms/js/3/jsignature/flashcanvas.js"></script>
<![endif]-->
<!--[if gte IE 9]>
<script type="text/javascript">
    
    if (document.documentMode < 9){
        var url = '<script type="text/javascript" src="' + '//formstack.com/forms/' + 'js/3/jsignature/flashcanvas.js"><\/script>';
        document.write(url);
    }
    
</script>
<![endif]-->
        <div id="signature72243585" class="fsSignature"><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"></div><canvas style="margin: 0px; padding: 0px; border: medium none; height: 25px; width: 100%;" class="jSignature" width="100" height="25"></canvas><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"></div></div>
    <div style="text-align: right">
        <a href="javascript://" class="fsSignatureClear" id="signatureClear72243585">
                            [clear]
                    </a>
    </div>
    <input type="hidden" id="field72243585" value="" name="field72243585" class="fsField" disabled="disabled">
                                                                                                        <div id="fsSupporting72243585" class="fsSupporting">Use your mouse or finger to draw your signature above</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-42" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243586" aria-describedby="fsSupporting72243586" fs-field-type="text" fs-field-validation-name="Date  " lang="en">
                                                                                                        <label id="label72243586" class="fsLabel" for="field72243586">Date                                                      </label>
                                            
                                        
                    <input type="text" id="field72243586" name="field72243586" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243586" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243587" fs-field-type="text" fs-field-validation-name="Print Name  " lang="en">
                                                                                                        <label id="label72243587" class="fsLabel" for="field72243587">Print Name                                                      </label>
                                            
                                        
                    <input type="text" id="field72243587" name="field72243587" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243588" aria-describedby="fsSupporting72243588" fs-field-type="text" fs-field-validation-name="Social Security No." lang="en">
                                                                                                        <label id="label72243588" class="fsLabel" for="field72243588">Social Security No.                                                    </label>
                                            
                                        
                    <input type="text" id="field72243588" name="field72243588" size="50" maxlength="9" value="000000000" class="fsField fsFormatText     fsFormatLength" disabled="disabled">
                                                                                                        <div id="fsSupporting72243588" class="fsSupporting">Without Dashes</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-43" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243589" aria-describedby="fsSupporting72243589" fs-field-type="text" fs-field-validation-name="Guarantor's Residential Address " lang="en">
                                                                                                        <label id="label72243589" class="fsLabel" for="field72243589">Guarantor's Residential Address                                                     </label>
                                            
                                        
                    <input type="text" id="field72243589" name="field72243589" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243589" class="fsSupporting">Street, City, State, Zip (Do not include PO Box)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243590" aria-describedby="fsSupporting72243590" fs-field-type="phone" fs-field-validation-name="Phone #     " lang="en">
                                                                                                        <label id="label72243590" class="fsLabel" for="field72243590">Phone #                                                         </label>
                                            
                                        
                    <input type="tel" id="field72243590" name="field72243590" size="2" value="" class="fsField fsFormatPhoneUS " disabled="disabled" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243590" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243591" aria-describedby="fsSupporting72243591" fs-field-type="text" fs-field-validation-name="Date of Birth " lang="en">
                                                                                                        <label id="label72243591" class="fsLabel" for="field72243591">Date of Birth                                                     </label>
                                            
                                        
                    <input type="text" id="field72243591" name="field72243591" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243591" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                                    
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-44" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243592" aria-describedby="fsSupporting72243592" fs-field-type="signature" fs-field-validation-name="Guarantor's Signature  " lang="en">
                                                                                                        <label id="label72243592" class="fsLabel" for="field72243592">Guarantor's Signature                                                      </label>
                                            
                                        
                    <!--[if lt IE 9]>
<script type="text/javascript" src="//formstack.com/forms/js/3/jsignature/flashcanvas.js"></script>
<![endif]-->
<!--[if gte IE 9]>
<script type="text/javascript">
    
    if (document.documentMode < 9){
        var url = '<script type="text/javascript" src="' + '//formstack.com/forms/' + 'js/3/jsignature/flashcanvas.js"><\/script>';
        document.write(url);
    }
    
</script>
<![endif]-->
        <div id="signature72243592" class="fsSignature"><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"></div><canvas style="margin: 0px; padding: 0px; border: medium none; height: 25px; width: 100%;" class="jSignature" width="100" height="25"></canvas><div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"></div></div>
    <div style="text-align: right">
        <a href="javascript://" class="fsSignatureClear" id="signatureClear72243592">
                            [clear]
                    </a>
    </div>
    <input type="hidden" id="field72243592" value="" name="field72243592" class="fsField" disabled="disabled">
                                                                                                        <div id="fsSupporting72243592" class="fsSupporting">Use your mouse or finger to draw your signature above</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-45" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan25" id="fsCell72243593" aria-describedby="fsSupporting72243593" fs-field-type="text" fs-field-validation-name="Date   " lang="en">
                                                                                                        <label id="label72243593" class="fsLabel" for="field72243593">Date                                                       </label>
                                            
                                        
                    <input type="text" id="field72243593" name="field72243593" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243593" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243594" fs-field-type="text" fs-field-validation-name="Print Name   " lang="en">
                                                                                                        <label id="label72243594" class="fsLabel" for="field72243594">Print Name                                                       </label>
                                            
                                        
                    <input type="text" id="field72243594" name="field72243594" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243595" aria-describedby="fsSupporting72243595" fs-field-type="text" fs-field-validation-name="Social Security No. " lang="en">
                                                                                                        <label id="label72243595" class="fsLabel" for="field72243595">Social Security No.                                                     </label>
                                            
                                        
                    <input type="text" id="field72243595" name="field72243595" size="50" maxlength="9" value="000000000" class="fsField fsFormatText     fsFormatLength" disabled="disabled">
                                                                                                        <div id="fsSupporting72243595" class="fsSupporting">Without Dashes</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-46" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell72243596" aria-describedby="fsSupporting72243596" fs-field-type="text" fs-field-validation-name="Guarantor's Residential Address " lang="en">
                                                                                                        <label id="label72243596" class="fsLabel" for="field72243596">Guarantor's Residential Address                                                     </label>
                                            
                                        
                    <input type="text" id="field72243596" name="field72243596" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243596" class="fsSupporting">Street, City, State, Zip (Do not include PO Box)</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25" id="fsCell72243597" aria-describedby="fsSupporting72243597" fs-field-type="phone" fs-field-validation-name="Phone #     " lang="en">
                                                                                                        <label id="label72243597" class="fsLabel" for="field72243597">Phone #                                                         </label>
                                            
                                        
                    <input type="tel" id="field72243597" name="field72243597" size="2" value="" class="fsField fsFormatPhoneUS " disabled="disabled" data-country="US" data-format="national">
                                                                                                        <div id="fsSupporting72243597" class="fsSupporting">(XXX) XXX-XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan25" id="fsCell72243598" aria-describedby="fsSupporting72243598" fs-field-type="text" fs-field-validation-name="Date of Birth  " lang="en">
                                                                                                        <label id="label72243598" class="fsLabel" for="field72243598">Date of Birth                                                      </label>
                                            
                                        
                    <input type="text" id="field72243598" name="field72243598" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                                                        <div id="fsSupporting72243598" class="fsSupporting">XX/XX/XXXX</div>
                                                                        
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
                                
                </div>
                                
            
                                        
                                        
            
            <div class="fsSection fs4Col" id="fsSection72406477">
                                                    
                                        
            <div class="fsSectionHeader">
        
    </div>
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-48" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243511" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 14px;"><em>1) The above applicant/buyer ("Applicant") represents that the information given in this application is complete and accurate and authorizes Card Issuer to check with credit reporting agencies, credit references and other sources disclosed to confirm information given; 2) Applicant requests a business charge account, if approved for credit, and one or more business charge cards from the card issuer, which is United Refining Company ("Card Issuer"); 3) Applicant agrees to the terms and conditions set forth in the Business Charge Account Agreement provided with this application and/or provided with the business charge card(s). Use of any card issued pursuant to this application confirms Applicant's agreement to said terms and conditions; 4) If this Account is for a partnership or a proprietorship, a partner or principal must sign this application and the undersigned's personal credit will be used in making a credit decision and they hereby authorize Card Issuer to obtain a consumer report. In the event that this application is denied based upon information contained in a consumer credit report of the undersigned, they authorize the Card Issuer to report the reason for the denial to the Applicant. Direct inquiries of businesses where the undersigned maintains accounts may also be made; 5) For and in consideration of this charge agreement, applicant/debtor agrees as an essential element hereof, in the event of any default, to pay reasonable attorney's fees, costs and interests for collection of any such charge, debt or obligations; 6) Applicant agrees that in the event the account is not paid as agreed, Card Issuer may report the undersigned's liability for and the status of the account to credit bureaus and others who may lawfully receive such information. If you have any questions regarding this application, please call 1-800-642-6478 Ext. 4837.</em></span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-49" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72243604" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p><span style="font-size: 14px;"><strong>We comply with Section 326 of the USA PATRIOT Act. This law mandates that we verify certain information about you while processing your application.&nbsp;</strong></span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-50" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell87572271" fs-field-type="select" fs-field-validation-name="How did you hear about the Kwik Fill Fleet Fueling program?" lang="en">
                                                                                                        <label id="label87572271" class="fsLabel" for="field87572271">How did you hear about the Kwik Fill Fleet Fueling program?                                                    </label>
                                            
                                        
                    <select id="field87572271" name="field87572271" size="1" class="fsField">
        <option value="Store Employee">Store Employee</option>
        <option value="Website">Website</option>
        <option value="Social Media">Social Media</option>
        <option value="Radio">Radio</option>
        <option value="Television">Television</option>
        <option value="Word of Mouth">Word of Mouth</option>
        <option value="Other">Other</option>
</select>
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-51" class="fsRow fsFieldRow fsLastRow fsHidden">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsHidden fsSpan100" id="fsCell87574045" fs-field-type="text" fs-field-validation-name="Please provide a short description of " other"="" source="" of="" information."="" lang="en">
                                                                                                        <label id="label87574045" class="fsLabel" for="field87574045">Please provide a short description of "Other" source of information.                                                    </label>
                                            
                                        
                    <input type="text" id="field87574045" name="field87574045" size="50" value="" class="fsField fsFormatText    " disabled="disabled">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-52" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell75879899" fs-field-type="richtext" fs-field-validation-name="" lang="en">
                                                        
                                        
                    <p style="text-align: center;"><span style="font-size: 24px;"><strong>Online Application Referral</strong></span></p><p><span style="font-size: 18px;">If referred by a Kwik Fill employee to complete the online application, please include the following information if available.</span></p>
                    
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-53" class="fsRow fsFieldRow">
            
                                        
            
            
            
            
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50" id="fsCell75879976" fs-field-type="text" fs-field-validation-name="Store #" lang="en">
                                                                                                        <label id="label75879976" class="fsLabel" for="field75879976">Store #                                                    </label>
                                            
                                        
                    <input type="text" id="field75879976" name="field75879976" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                        
                    
                
                    
            
            
            
                                        
                                        
                                        
            
                                        
            
                                        
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50" id="fsCell75879993" fs-field-type="text" fs-field-validation-name="Employee #" lang="en">
                                                                                                        <label id="label75879993" class="fsLabel" for="field75879993">Employee #                                                    </label>
                                            
                                        
                    <input type="text" id="field75879993" name="field75879993" size="50" value="" class="fsField fsFormatText    ">
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                        
                
                    
            
            
            
                                        
                                        
                                        
            
                                                
                <div id="fsRow3293484-54" class="fsRow fsFieldRow fsLastRow">
            
                                        
            
            
            
                                        
                        
                        
            <div class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100" id="fsCell72464388" fs-field-type="textarea" fs-field-validation-name="Additional Information" lang="en">
                                                                                                        <label id="label72464388" class="fsLabel" for="field72464388">Additional Information                                                    </label>
                                            
                                        
                    
<textarea id="field72464388" class="fsField " name="field72464388" rows="10" cols="50"></textarea>
                                                                
                    
                    
                    
                                                </div>
                                          <div class="fs-clear"></div>
                        </div>
                        
                    
        
    </div>
        
</div>
  
<div id="fsSubmit3293484" class="fsSubmit fsPagination">
    <button type="button" id="fsPreviousButton3293484" class="fsPreviousButton" value="Previous Page" style="display:none;" aria-label="Previous"><span class="fsFull">Previous</span><span class="fsSlim">←</span></button>
    <button type="button" id="fsNextButton3293484" class="fsNextButton" value="Next Page" style="display:none;" aria-label="Next"><span class="fsFull">Next</span><span class="fsSlim">→</span></button>
    <input id="fsSubmitButton3293484" class="fsSubmitButton" style="" type="submit" value="Submit Form">
    
    
            <div style="color:#333;background-color:#fff;border:1px solid #ccc; width:167px;margin:10px auto;padding:5px 10px 5px 5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border-radius:5px;font-family:Helvetica,Arial,sans-serif;font-size:11px" class="stacklock" lang="en">
          <img src="https://www.formstack.com/admin/images/stacklock.png" alt="Form secured by Formstack" width="18" height="18" align="absmiddle">
          <div style="float: right;margin-top: 4px;">
            Form secured by
            <a href="http://www.formstack.com/try-formstack?utm_source=stacklock&amp;utm_medium=product&amp;utm_campaign=product+branding&amp;fa=stacklock,3293484" target="_blank" rel="noopener nofollow" style="color:green;font-weight:bold">
              Formstack
            </a>
          </div>
        </div>
    
  <div class="clear"></div>
  <div class="withAds">
      </div>
</div>
    <script type="text/javascript">
        window.FS_FIELD_DATA_3293484 = [];
    </script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/jquery.min_1d14cd3798.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/jquery-ui.min_42a497cb9f.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/scripts_0edcde2e8b.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/analytics_7d49daa365.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/jsignature/jSignature.min_6651ad6080.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/libphonenumber-min_6f64debfdd.js"></script>
            <script type="text/javascript" src="//static.formstack.com/forms/js/3/modernizr_60a2d5aeb5.js"></script>
    
    <script type="text/javascript">
                (function() {
          var isLocalStorageSafe = true;
          try {
              if (typeof sessionStorage !== 'undefined' && sessionStorage.fsFonts) {
                document.documentElement.className = document.documentElement.className += ' wf-active';
              }
          } catch (e) {
            console.log('Failed to read from localStorage', e.message);
            isLocalStorageSafe = false;
          }
          var pre = document.createElement('link');
          pre.rel  = 'preconnect';
          pre.href = 'https://fonts.googleapis.com/';
          pre.setAttribute('crossorigin', '');
          var s = document.getElementsByTagName('head')[0];
          s.appendChild(pre);
          var fontConfig = {
            google: {
              families: [
                'Lato:400,700'
              ]
            },
            timeout: 2000,
            active: function() {
              if ( !isLocalStorageSafe || typeof sessionStorage === 'undefined') {
                return;
              }
              sessionStorage.fsFonts = true;
            }
          };
          if (typeof WebFont === 'undefined') {
              window.WebFontConfig = fontConfig;
              var wf = document.createElement('script');
              wf.type  = 'text/javascript';
              wf.async = 'true';
              wf.src   = ('https:' == document.location.protocol ? 'https' : 'http') +
                         '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
              s.appendChild(wf);
          } else {
            WebFont.load(fontConfig);
          }
        })();
        
        if(window.addEventListener) {
            window.addEventListener('load', loadFormstack, false);
        } else if(window.attachEvent) {
            window.attachEvent('onload', loadFormstack);
        } else {
            loadFormstack();
        }
        
        function loadFormstack() {
            var form3293484 = new Formstack.Form(3293484, 'https://secureit.formstack.com/forms/');
            
            
                        form3293484.checks.push({target: '72243575', action: 'Show', bool: 'AND', fields: ['72243545'],checks: [{field: '72243545', condition: '==', option: 'Yes (If yes, complete the Personal Guaranty below.)'}]});
                        form3293484.checks.push({target: '72243576', action: 'Show', bool: 'AND', fields: ['72243545'],checks: [{field: '72243545', condition: '==', option: 'Yes (If yes, complete the Personal Guaranty below.)'}]});
                        form3293484.checks.push({target: '72243577', action: 'Show', bool: 'AND', fields: ['72243545'],checks: [{field: '72243545', condition: '==', option: 'Yes (If yes, complete the Personal Guaranty below.)'}]});
                        form3293484.checks.push({target: '87574045', action: 'Show', bool: 'AND', fields: ['87572271'],checks: [{field: '87572271', condition: '==', option: 'Other'}]});
            
            form3293484.logicFields = ['87572271','72243545'];
            
            form3293484.calcFields = [];
            
            form3293484.dateCalcFields = [];
            form3293484.init();
                        if (Formstack.Analytics) {
                form3293484.plugins.analytics = new Formstack.Analytics('https://secureit.formstack.com', 3293484, form3293484);
                form3293484.plugins.analytics.trackTouch();
                form3293484.plugins.analytics.trackBottleneck();
            }
            
            
            
            
            window.form3293484 = form3293484;
        };
    </script>
<input name="fsUserAgent" id="fsUserAgent" type="hidden" value="Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/110.0"></form>
<div class="fs-ngdialog fs-modal-small fs-form-dialog fs-form-dialog--hidden">
  <div class="fs-ngdialog-overlay"></div>
  <div class="fs-ngdialog-content">
    <div class="fs-modal__top fs-form-dialog__title"></div>
    <div class="fs-modal__middle">
      <div class="fs-form-dialog__message"></div>
      <label class="hidden" for="fsSaveResumePassword">Enter your save and resume password</label>
      <input type="password" id="fsSaveResumePassword" class="fs-form-input fs-form-dialog__password fs-form-dialog--hidden fs--mt20" placeholder="Enter your save and resume password">
       <textarea class="fs-form-dialog__textarea fs-form-dialog--hidden" rows="3" style="width: 100%; margin-top: 10px" aria-label="Add an optional comment"></textarea>
    </div>
    <div class="fs-modal__bottom">
      <a class="fs-form-dialog__cancel fs-btn2 fs-btn2--size_medium fs-btn2--style_edit-dark" title="Cancel">
        <div class="fs-btn2__content">
          <div class="fs-btn2__text">
            <span class="fs-form-dialog__button-text">Cancel</span>
          </div>
        </div>
      </a>
      <a class="fs-form-dialog__confirm fs-btn2 fs-btn2--size_medium fs-btn2--style_create fs--float-right" title="Confirm">
        <div class="fs-btn2__content">
          <div class="fs-btn2__text">
            <span class="fs-form-dialog__button-text">Confirm</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
</div>
`